// The logo PNG has the wordmark + steering wheel on top, then a green
// horizontal line, then "MEDIA ON AUTO PILOT" + "AI-POWERED CONTENT AGENCY"
// tagline lines at the bottom. At small sizes (nav header), those taglines
// are unreadable. We crop visually so only the top portion (wordmark +
// wheel) shows.
//
// Vertical layout in the 1260×594 PNG (measured by canvas pixel scan):
//   31% — 73% : steering wheel + MOAP wordmark letters
//   79%       : thin green horizontal line
//   83% — 86% : "MEDIA ON AUTO PILOT" subtitle
//   90% — 92% : "AI-POWERED CONTENT AGENCY" tagline
//
// Showing the top 75% drops everything below the green line — both
// subtitle + tagline + line itself. Just above is the wordmark bottom
// edge at 73%, so 75% leaves a 2% breathing margin to avoid clipping
// the wordmark.
const VISIBLE_HEIGHT_PCT = 0.75;
const PNG_W = 1260;
const PNG_H = 594;

export const Logo = ({ size = 36, stacked = false }) => {
  const naturalRenderHeight = stacked ? size * 4.5 : size * 2.6;
  const croppedRatio        = `${PNG_W} / ${PNG_H * VISIBLE_HEIGHT_PCT}`;

  // The span enforces the cropped aspect ratio. Whatever width the layout
  // gives it, the span height = width × croppedRatio. The img inside is
  // sized to the FULL natural aspect ratio (top: 0, width: 100%, height:
  // auto), so its bottom extends past the span — `overflow: hidden` clips
  // exactly the unwanted bottom portion. This works regardless of whether
  // the parent constrains width, height, or both.
  return (
    <span style={{
      display:     "inline-block",
      overflow:    "hidden",
      aspectRatio: croppedRatio,
      maxHeight:   naturalRenderHeight * VISIBLE_HEIGHT_PCT,
      maxWidth:    "100%",
      lineHeight:  0,
    }}>
      <img
        src={stacked ? "/logos/logo-stacked.png" : "/logos/logo-horizontal.png"}
        alt="Media on Auto Pilot"
        style={{
          display: "block",
          width:   "100%",
          height:  "auto",
          objectFit: "contain",
          borderRadius: 4,
        }}
      />
    </span>
  );
};
